import { useEffect, useState } from "react";
import { Card, Spinner } from "react-bootstrap";
import { endpoints } from "../../helpers/Endpoints";
import { api } from "../../helpers/apiCore";

interface DashboardSummary {
  totalUsers: number;
  activeUsers: number;
  totalSchoolAmount: number;
  schoolPaymentCount: number;
  totalBillAmount: number;
  billTransactionCount: number;
  totalTransferAmount: number;
  transferTransactionCount: number;
}

const StatsCards = () => {
  const [dashboardData, setDashboardData] = useState<DashboardSummary | null>(null);

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        api.setAuthorization(api.getLoggedInUser());
        const response = await api.get(endpoints.getDashboardSummary, {});
        setDashboardData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchDashboardData();
  }, []);

  const formatNumber = (num: number | bigint) =>
    new Intl.NumberFormat().format(num);

  const statsMapping = dashboardData ? [
    {
      title: "Total Users",
      value: formatNumber(dashboardData.totalUsers),
      subtitle: `${formatNumber(dashboardData.activeUsers)} Active`
    },
    {
      title: "School Payments",
      value: `₦${formatNumber(dashboardData.totalSchoolAmount)}`,
      subtitle: `${formatNumber(dashboardData.schoolPaymentCount)} Payments`
    },
    {
      title: "Bills",
      value: `₦${formatNumber(dashboardData.totalBillAmount)}`,
      subtitle: `${formatNumber(dashboardData.billTransactionCount)} Transactions`
    },
    {
      title: "Transfers",
      value: `₦${formatNumber(dashboardData.totalTransferAmount)}`,
      subtitle: `${formatNumber(dashboardData.transferTransactionCount)} Transactions`
    },
  ] : [];

  return (
    <div className="cards-section">
      {!dashboardData ? (
        <Spinner animation="border" size="sm" />
      ) : (
        statsMapping.map((stat, index) => (
          <Card key={index} className="stats-card">
            <Card.Body>
              <Card.Title>{stat.title}</Card.Title>
              <Card.Text className="stats-value">{stat.value}</Card.Text>
              <Card.Text className="stats-subtitle">{stat.subtitle}</Card.Text>
            </Card.Body>
          </Card>
        ))
      )}
    </div>
  );
};

export default StatsCards;
